import React from "react";
import {connect} from "react-redux";
import {Image, ImageBackground} from "react-native";

export class Logo extends React.Component{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.logoPicto;
    }

    render() {

        return (<Image style={[{width: 20, height: 25}]} resizeMode={"contain"} source={(!this.props.isDark) ? this.picto.light : this.picto.dark}  />);
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(Logo);


class ScaledImage extends React.Component {
  constructor(props) {
      super(props);
      this.state = { source: { uri: this.props.uri } };
  }

  componentWillMount() {
      Image.getSize(this.props.uri, (width, height) => {
          if (this.props.width && !this.props.height) {
              this.setState({
                  width: this.props.width,
                  height: height * (this.props.width / width)
              });
          } else if (!this.props.width && this.props.height) {
              this.setState({
                  width: width * (this.props.height / height),
                  height: this.props.height
              });
          } else {
              this.setState({ width: width, height: height });
          }
      });
  }

  render() {
      return (
          <Image
              source={this.state.source}
              style={{ height: this.state.height, width: this.state.width }}
          />
      );
  }
}

const BOLogo = ({ style }) => {
  return <ScaledImage height={25} uri={'/app_config/icon'} />
}

export { BOLogo }

